import {selector} from './selector';

const PagePaymentProcessForm = (function ($) {

    function redirectForm() {
        $(selector.form).submit();
    }

    function initialize() {
        setTimeout(redirectForm, 2000);
    }

    return {
        init: initialize
    }
})(jQuery);

export {PagePaymentProcessForm};